import z from 'zod/v4';
import { EnumParams } from '../events.types';
import { eventLeaderboardSectionSchema, leaderboardLeagueSchema } from './event-leaderboard-schema';

// Guild leaderboards have no user targeting: leagues drop it here, and the UI hides the
// event-level section. components.userTargeting stays optional in the shared schema because
// experiments write each variant's A/B group into it, and saving the form keeps it.
export const guildLeaderboardLeagueSchema = (enums?: EnumParams) =>
  leaderboardLeagueSchema(enums).omit({ userTargeting: true });

export const guildEventLeaderboardSectionSchema = (enums?: EnumParams) =>
  eventLeaderboardSectionSchema(enums).extend({
    leagues: z.array(guildLeaderboardLeagueSchema(enums)),
  });
